import type { loan_application } from '@axo/shared/data-access/types';
import type { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export function getLoanApplicationDependencies(api: IAPI) {
  return async function getLoanApplicationDependencies(
    id: string
  ): Promise<loan_application.Dependency[]> {
    return send({
      baseURL: api.url.service,
      path: `/loan-application/${id}/dependencies`,
      token: api.token,
      method: 'GET',
    });
  };
}

export function renewLoanApplicationDependency(api: IAPI) {
  return async function renewLoanApplicationDependency(
    applicationID: string,
    dependencyID: string
  ): Promise<loan_application.Dependency> {
    return send({
      baseURL: api.url.service,
      path: `/loan-application/${applicationID}/dependencies/${dependencyID}/renew`,
      token: api.token,
      method: 'POST',
    });
  };
}
